import React, { useState } from 'react';
import '@/App.css';
import { Star, MapPin, Clock, Users, Phone, Mail, MessageCircle, X } from 'lucide-react';

const TOURS = [
  {
    id: 1,
    title: 'Ницца — первое свидание',
    description: 'Посетить главные достопримечательности города и узнать истории его знаменитых жителей',
    fullDescription: {
      intro: 'Вы увидите самые интересные места Ниццы: площадь Массена, Английский променад, Дворец Ласкари, Замковый холм, дом Матисса. Не перегружая вас сухими фактами и датами, я расскажу историю города через сюжеты о происшествиях с его известными обитателями. А еще вы зайдете на местный рынок, попробуете французские блинчики и пироги и получите полезную информацию о транспорте, музеях и мероприятиях. Я помогу понять прекрасную Ниццу и влюбиться в нее навсегда!',
      sections: [
        {
          title: 'Ницца: история и судьбы',
          content: 'В первой части экскурсии вы посетите площадь Массена и услышите связанные с ней пикантные факты. Я расскажу трагическую историю здания Оперы, дотла уничтоженного пожаром и впоследствии восстановленного. Вместе мы отыщем на одной из уютных улочек старейшую карту города и посмотрим, как выглядела Ницца много веков назад. Далее зайдем на рыночную площадь, которая покорит вас красками и разнообразием выбора. Вы сможете попробовать местные блинчики Сокка из бобовой муки и пироги Писаладье с карамелизованным луком. Также я с удовольствием расскажу истории знаменитых людей, связанных с Ниццей: Паганини, Матисса, Фицджеральда и даже легендарного городского грабителя.'
        },
        {
          title: 'Ницца с высоты птичьего полета',
          content: 'Вы увидите кафедральный собор Ниццы, построенный в 17 веке, и узнаете легенду о святой Репарате. Посетите Замковый холм, где раньше находилась крепость, и насладитесь свежестью искусственного водопада неподалеку от смотровой площадки. С холма вам откроются захватывающие панорамные виды на старую Ниццу, порт и великолепный Английский променад. Следом я покажу знаменитую башню Тур Белланда, Дворец правосудия и прилегающую к нему площадь, а также старинные отели, построенные на пике туристического бума 19 века. В завершение вы заглянете в церковь Иисуса и рассмотрите изящный фасад Дворца Ласкари, где расположен музей старинных музыкальных инструментов.'
        }
      ]
    },
    duration: '2 часа',
    type: 'Пешком',
    location: 'Ницца',
    price: '€134',
    groupSize: '1–7 чел.',
    rating: 4.97,
    reviews: 160,
    promoted: true,
    image: 'https://customer-assets.emergentagent.com/job_french-riviera-tours/artifacts/r5ovco0z_IMG-20240305-WA0005.jpg'
  },
  {
    id: 2,
    title: 'Монако',
    description: 'Изучить все главные места княжества и почувствовать его пульс',
    fullDescription: {
      intro: 'Вы составите мнение и о современной люксовой части города, и об исторической. Казино и район Монте-Карло, трасса Формулы 1, Княжеский дворец, порт с белоснежными яхтами и собор: эти места станут фоном для рассказов о прошлом княжества, его правителях и жителях.',
      sections: [
        {
          title: 'Идеальное знакомство с княжеством',
          content: 'Вы сразу оцените Монако: мы начнем прогулку с панорамного балкончика, где восхитимся гаванью, и заглянем в туристический офис — за красивым штемпелем княжества в паспорте. С крыши отеля вы увидите новый строящийся район прямо на воде. А прокатившись на городском лифте, почувствуете заботу принца о жителях и путешественниках. Кроме того, вас ждет короткая прогулка на катере в порту Эркюль.\n\nВ Старом городе посмотрим на Княжеский дворец и Кафедральный собор. Узкими улочками выйдем к музею океанографии в здании на краю скалы.\n\nОтдельной темой станет транспорт по-монакски. Мы пройдем по участку трассы Формулы 1, найдем памятник гонщику и посмотрим на «выставку» роскошных авто у казино Монте-Карло. А в финале выйдем к музею старинных и гоночных машин из коллекции принца Ренье, который можно посетить после прогулки.'
        },
        {
          title: 'Феномен Монако',
          content: 'За 3 часа вы разберетесь в особенностях карликового государства. Я расскажу о его устройстве и об истории старейшей династии, правящей в Монако. Вы услышите о том, как первый принц захватил эти земли, о семье и увлечениях нынешнего князя Альберта II. Поговорим также о менталитете и жизни монегасков, о самых знаменитых владельцах яхт и элитной недвижимости в городе.'
        }
      ]
    },
    duration: '2,5 часа',
    type: 'Пешком',
    location: 'Монако',
    price: '€167',
    groupSize: '1–7 чел.',
    rating: 5.0,
    reviews: 47,
    promoted: true,
    image: 'https://customer-assets.emergentagent.com/job_french-riviera-tours/artifacts/sa9s1wy2_IMG-20240806-WA0023.jpg'
  },
  {
    id: 3,
    title: 'Канны: кино и не только',
    description: 'Курьезные рассказы о фестивале, старый квартал Сюке и истории о монахах и средневековом замке',
    fullDescription: {
      intro: 'Вы услышите любопытные истории Каннского фестиваля, почувствуете себя звездой, пройдя по красной дорожке, и увидите шедевры стрит-арта, посвященные миру кино. В старом квартале Сюке осмотрите средневековый замок, полюбуетесь видом на город и узнаете легенды Леринских островов.',
      sections: [
        {
          title: 'Мероприятие, принесшее городу мировую известность',
          content: 'Мы пройдем по Аллее звезд и увидим большую часть коллекции «звездных рук». Поговорим об известных актрисах: Бриджит Бордо, Грейс Келли и Татьяне Самойловой, о Мэрил Стрип, Джулии Робертс и других. На красной дорожке, ведущей ко входу во Дворец Кинофестивалей, устроим небольшую фотосессию. Я расскажу о причинах создания фестиваля и необычных случаях, произошедших на этом мероприятии. А иллюстрациями к рассказу станут огромные граффити на стенах в городе, посвящённые кино и знаменитым актерам.'
        },
        {
          title: 'Не кино единым',
          content: 'Канны — это не только фестиваль. На роскошной набережной Круазетт вы полюбуетесь лазурным морем и услышите о её названии. По узким улочкам Старого года мы поднимемся на вершину холма Сюке. С панорамной площадки откроется вид на раскинувшийся у берега город и остров Сен-Оноре, где с 5 века и по сей день трудятся монахи Леринского аббатства. Я расскажу о роли аббатов в истории Канн и поведаю легенду о человеке в железной маске, который был заключен на соседнем острове Сен-Маргерит. После мы осмотрим средневековый замок Кастр — вы узнаете, что сегодня находится за мощными стенами — и заглянем в романскую церковь Нотре Дам д\'Эсперанс, где вы увидите фрески Жоржа Ру и позолоченную статую святой Анны 15 века.'
        }
      ]
    },
    duration: '2 часа',
    type: 'Пешком',
    location: 'Канны',
    price: '€137',
    groupSize: '1–7 чел.',
    rating: 4.81,
    reviews: 27,
    promoted: true,
    image: 'https://customer-assets.emergentagent.com/job_french-riviera-tours/artifacts/4kfch7c3_kanny-francia-25-oktabra-2017-g-uglovoi-vid-na-znamenityi-kupol-otela-carlton-international-raspolozennogo-na-bul-vare-kruazet-v-kannah-francia.jpg'
  },
  {
    id: 4,
    title: 'Из Ниццы — в деревушку Эз-Вилляж',
    description: 'Совместить путешествие в средние века с погружением в историю парфюмерии',
    fullDescription: {
      intro: 'Эз — небольшая деревня между Ниццей и Монако. Кажется, что её узкие тенистые улочки почти всегда пустынны. Но стоит присмотреться — и обнаруживаешь сувенирные лавки, парфюмерные бутики, знаменитые мишленовские рестораны и отели в старинных шато. Я проведу вас тайными переулками мимо старинных башен, развалин замка, сада с экзотическими растениями к вершине холма, откуда открывается вид до самого Сан-Тропе.',
      sections: [
        {
          title: 'Что вас ожидает',
          content: 'Наша экскурсия будет проходить в формате лёгкой и непринуждённой прогулки. Я покажу самые красивые панорамные виды, а также расскажу о достопримечательностях, которыми в своё время восхищались Ницше, Уолт Дисней и члены королевской семьи Швеции.\n\nНачнём около знаменитой тропы Ницше, по которой автор трактата «Так говорил Заратустра» прогуливался каждый день, черпая вдохновение для своих книг. Пройти по стопам философа удаётся не всем: потребуется недюжинная физическая подготовка и минимум полтора часа. Если отважитесь, после экскурсии вы сможете это сделать самостоятельно.'
        },
        {
          title: 'Маршрут экскурсии',
          content: 'Зайдя в главные ворота, мы попадём в Старый город, где узенькие улочки разбегаются в разные стороны. По одной из тропинок мы дойдём до замка Эз, который долгое время являлся резиденцией шведского короля Гийома.\n\nДалее мы увидим знаменитый отель с мишленовским рестораном «Золотой барашек», где я поделюсь легендой об этом культовом месте и расскажу о некоторых «звёздных» гостях.\n\nЗатем мы выйдем на самое плоское место в городе — площадь Ле Планет, где найдём первый источник питьевой воды в деревне.\n\nВ середине экскурсии мы заглянем в самое старое здание деревни, Часовню Белых Кающихся грешников, где увидим старинный крест 14 века. Там я расскажу об этом братстве и его деятельности, которую представители ордена продолжают и по сей день.\n\nДобравшись до вершины холма, мы попадём в Экзотические сады, которые поражают великолепными видами и изобилием редких кактусовых растений. Также я познакомлю вас с творчеством скульптора Жана-Филиппа Ришара, чьи работы расставлены по всему саду.\n\nВ конце экскурсии мы посетим знаменитую парфюмерную фабрику «Фрагонар» и изучим её историю. Там вы понаблюдаете за рождением парфюмерных изделий с цветочными и цитрусовыми ароматами.'
        }
      ]
    },
    duration: '3 часа',
    type: 'Пешком',
    location: 'Ницца',
    price: '€147',
    groupSize: '1–7 чел.',
    rating: 5.0,
    reviews: 9,
    promoted: false,
    image: 'https://customer-assets.emergentagent.com/job_french-riviera-tours/artifacts/bxi1qxvw_tvoyariviera.com-eze_01.jpg'
  },
  {
    id: 5,
    title: 'Ментон — лимонный рай!',
    description: 'Погрузиться в разнообразие архитектуры, флоры и красок цитрусового городка',
    fullDescription: {
      intro: 'Когда Адама и Еву изгнали из рая, Ева успела взять с собой лимон: она обещала оставить его в месте, напоминающем рай. Такой чести удостоился Ментон — посетив этот город, вы поймёте её выбор. Вы прогуляетесь по садам Биовэ, полюбуетесь архитектурой старых улочек и попробуете цитрусовые сладости. А приятные цветочные ароматы будут сопровождать нас на протяжении всей прогулки.',
      sections: [
        {
          title: 'Фестиваль лимонов и райские сады',
          content: 'Климат Ментона очень благоприятен для цитрусовых, и каждый февраль в садах Биовэ здесь проходит крупнейшая в мире выставка фигур из лимонов и апельсинов. Невероятные скульптуры поражают воображение — я открою вам их смысл и значение фестиваля для города. А в другие месяцы мы насладимся красотой этих садов с сезонными цветами, растениями, фонтанами и скульптурами.'
        },
        {
          title: 'Вкусы Ментона',
          content: 'Конечно, здесь из лимонов изготавливают сладости, напитки и косметические средства. Вы узнаете о самых популярных цитрусовых блюдах этого региона, а в маленьком музейчике-магазине попробуете знаменитые лимонные лакомства: пастилу, лимончелло, печенье и масла.'
        },
        {
          title: 'Ментон интернациональный',
          content: 'Пройдя по главной пешеходной улице, мы поднимемся в Старый город: вам откроются прекрасные виды на Италию. Яркая итальянская архитектура домиков и барочное убранство церкви архангела Михаила поразят своим великолепием. Мы найдем знаки, напоминающие о династии Гримальди — я расскажу о тех временах, когда Ментон принадлежал княжеству Монако. Прогуляемся по мощеным улочкам, ведущим к замковому кладбищу, где похоронены русские эмигранты, и поговорим о русской диаспоре, проживавшей в Ментоне с 1860 года. На променаде де Солей увидим бастион, где хранятся работы талантливого художника и режиссера Жана Кокто. А старинная башня 15 века скоро предстанет перед нами в новом виде после реновации.'
        }
      ]
    },
    duration: '2 часа',
    type: 'Пешком',
    location: 'Ментон',
    price: '€147',
    groupSize: '1–7 чел.',
    rating: 5.0,
    reviews: 17,
    promoted: false,
    image: 'https://customer-assets.emergentagent.com/job_french-riviera-tours/artifacts/4nxpcqgm_IMG_20240306_153446_157.jpg'
  },
  {
    id: 6,
    title: 'Из Ниццы в гости к Ренуару в Кань-сюр-Мер',
    description: 'Побывать в мастерской легендарного импрессиониста и пройти по улицам, где витает творческий дух',
    fullDescription: {
      intro: 'Огюст Ренуар был очарован яркими красками Лазурного берега и маленьким городком Кань-сюр-Мер. Вы исследуете виллу, где жил и работал автор, и услышите, каким был его творческий путь. Прогуляетесь по уютным улочкам и представите, что здесь вдохновляло художников. Побываете в церкви в стиле барокко и в нескольких мастерских местных ремесленников.',
      sections: [
        {
          title: 'Вилла Коллет — дом и мастерская Ренуара',
          content: 'Здесь Ренуар и его семья прожили более 10 лет. Я расскажу, как строили дом и сад, и объясню, почему художник выбрал именно это место.\n\nВы найдёте копии знаменитых картин в саду в тех местах, где они были написаны. Изучите мастерскую Огюста и его дом. Увидите быт начала 20 века, оригинальную мебель и декор, коллекцию работ Ренуара и полотна, которые ему посвятили его друзья.'
        },
        {
          title: 'Прогулка по городу, дома художников и ремесленнические мастерские',
          content: 'Мы заглянем к художникам, ювелирам и керамистам. Они расскажут нам о своём ремесле. Вы найдёте дома Модильяни, Сутина и Кляйна и оцените изящное барочное убранство местной церкви.'
        }
      ]
    },
    duration: '3 часа',
    type: 'Пешком',
    location: 'Ницца',
    price: '€139',
    groupSize: '1–4 чел.',
    rating: 5.0,
    reviews: 1,
    promoted: false,
    image: 'https://customer-assets.emergentagent.com/job_french-riviera-tours/artifacts/krajvzui_OIP.webp'
  }
];

const REVIEWS = [
  {
    id: 1,
    name: 'Наталья',
    date: '1 января 2026',
    tour: 'Ницца — первое свидание',
    text: 'Экскурсия очень понравилась!!! Полина прекрасный экскурсовод, столько нового узнали, очень интересно и познавательно, будем рекомендовать друзьям и знакомым, спасибо большое!!!',
    experience: '10 экскурсий'
  },
  {
    id: 2,
    name: 'Эльмира',
    date: '12 декабря 2025',
    tour: 'Монако',
    text: 'Были с мужем на трех экскурсиях с Полиной во время посещения Лазурного берега. Остались в восторге от всех трех экскурсий! Полина очень интеллигентный человек, интересный рассказчик, и просто приятная и красивая женщина. С ней Франция заиграла еще более яркими красками! К тому же она всегда готова была помочь в любых бытовых ситуациях, от покупки билетов до резерваций ресторанов. Очень рекомендую Полину, если решите посетить Лазурный берег.',
    experience: '11 экскурсий'
  },
  {
    id: 3,
    name: 'Ludmila',
    date: '29 ноября 2025',
    tour: 'Монако',
    text: 'Полина просто великолепный экскурсовод',
    experience: '9 экскурсий'
  },
  {
    id: 4,
    name: 'Вероника',
    date: '17 ноября 2025',
    tour: 'Ментон — лимонный рай!',
    text: 'Прекрасная Полина, легкая в общении и улыбчивая, прекрасно и глубоко знает Францию, экскурсию ведет непринужденно и интересно, однозначно рекомендую всем, кто хочет насладиться лазурным берегом! Обязательно вернемся!',
    experience: '39 экскурсий'
  },
  {
    id: 5,
    name: 'Юлия',
    date: '11 ноября 2025',
    tour: 'Монако',
    text: 'Полина, большое спасибо за экскурсию в Монако! Полина купила нам билеты, встретила нас на станции жд, привела нас после экскурсии в ресторан на обед, а также рассказала, как добраться до жд вокзала! За это отдельное спасибо! Полина очень интересно рассказывала о Монако, королевской семье, жителей и инвесторах Монако! А еще сама экскурсия была очень разнообразная и хорошо организована! Мы получили истинное наслаждение! Большое Вам спасибо!',
    experience: '17 экскурсий'
  }
];

function App() {
  const [selectedTour, setSelectedTour] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    tour: '',
    date: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
      const response = await fetch(`${backendUrl}/api/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      
      const data = await response.json();
      
      if (data.success) {
        alert('Спасибо за заявку! Полина свяжется с вами в ближайшее время.');
        // Reset form
        setFormData({
          name: '',
          email: '',
          phone: '',
          tour: '',
          date: '',
          message: ''
        });
      } else {
        alert('Произошла ошибка при отправке. Пожалуйста, попробуйте позже или свяжитесь напрямую: polina.travel06@gmail.com');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Произошла ошибка при отправке. Пожалуйста, попробуйте позже или свяжитесь напрямую: polina.travel06@gmail.com');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50">
      {/* Header */}
      <header className="bg-white/80 backdrop-blur-md shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex justify-between items-center">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white font-bold text-xl">
                П
              </div>
              <div>
                <h1 className="text-xl font-bold text-gray-900">Полина</h1>
                <p className="text-sm text-gray-600">Гид по Лазурному берегу</p>
              </div>
            </div>
            <nav className="hidden md:flex space-x-8">
              <a href="#tours" className="text-gray-700 hover:text-blue-600 transition">Экскурсии</a>
              <a href="#reviews" className="text-gray-700 hover:text-blue-600 transition">Отзывы</a>
              <a href="#contact" className="text-gray-700 hover:text-blue-600 transition">Контакты</a>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-5xl font-bold text-gray-900 mb-6 leading-tight">
            Откройте для себя<br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">
              Французскую Ривьеру
            </span>
          </h2>
          <p className="text-xl text-gray-700 mb-8 leading-relaxed">
            Добрый день, меня зовут Полина. Я много путешествовала по Франции, изучая её историю и язык. За это время мне довелось узнать множество удивительных фактов и легенд, которыми я с радостью поделюсь с вами.
          </p>
          <p className="text-lg text-gray-600 mb-8">
            Общение с путешественниками дарит мне истинное удовольствие. На моих экскурсиях вы будете чувствовать себя комфортно, сблизитесь с чудесными южными городками и увидите их с лучшей стороны!
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a href="#tours" className="px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-full font-semibold hover:shadow-lg transform hover:-translate-y-0.5 transition">
              Посмотреть экскурсии
            </a>
            <a href="#contact" className="px-8 py-4 bg-white text-gray-700 rounded-full font-semibold border-2 border-gray-300 hover:border-blue-600 hover:text-blue-600 transition">
              Связаться со мной
            </a>
          </div>
        </div>
      </section>

      {/* Tours Section */}
      <section id="tours" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Мои экскурсии</h2>
            <p className="text-xl text-gray-600">Выберите путешествие по вашему вкусу</p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {TOURS.map((tour) => (
              <div key={tour.id} className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2" data-testid={`tour-card-${tour.id}`}>
                <div className="relative overflow-hidden">
                  <img 
                    src={tour.image} 
                    alt={tour.title} 
                    className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{tour.title}</h3>
                  <p className="text-gray-600 mb-4 line-clamp-2">{tour.description}</p>
                  <div className="space-y-2 mb-4">
                    <div className="flex items-center text-sm text-gray-600">
                      <Clock className="w-4 h-4 mr-2" />
                      {tour.duration}
                    </div>
                    <div className="flex items-center text-sm text-gray-600">
                      <MapPin className="w-4 h-4 mr-2" />
                      {tour.location}
                    </div>
                    <div className="flex items-center text-sm text-gray-600">
                      <Users className="w-4 h-4 mr-2" />
                      {tour.groupSize}
                    </div>
                  </div>
                  <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                    <div>
                      <div className="text-2xl font-bold text-blue-600">{tour.price}</div>
                      <div className="text-sm text-gray-500">за группу</div>
                    </div>
                    <div className="flex gap-2">
                      {tour.fullDescription && (
                        <button 
                          onClick={() => setSelectedTour(tour)}
                          className="px-4 py-2 bg-gray-100 text-gray-700 rounded-full font-semibold hover:bg-gray-200 transition"
                          data-testid={`details-tour-${tour.id}`}
                        >
                          Подробнее
                        </button>
                      )}
                      <a href="#contact" className="px-6 py-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-full font-semibold hover:shadow-lg transition" data-testid={`book-tour-${tour.id}`}>
                        Забронировать
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Reviews Section */}
      <section id="reviews" className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-blue-50 to-purple-50">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {REVIEWS.map((review) => (
              <div key={review.id} className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition" data-testid={`review-${review.id}`}>
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white font-bold">
                    {review.name[0]}
                  </div>
                  <div className="ml-3">
                    <h4 className="font-semibold text-gray-900">{review.name}</h4>
                    <p className="text-sm text-gray-500">{review.experience}</p>
                  </div>
                </div>
                <div className="flex items-center mb-3">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>
                <p className="text-gray-700 mb-3 leading-relaxed">{review.text}</p>
                <div className="pt-3 border-t border-gray-200">
                  <p className="text-sm text-gray-500 mb-1">{review.tour}</p>
                  <p className="text-xs text-gray-400">{review.date}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section id="contact" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Забронировать экскурсию</h2>
            <p className="text-xl text-gray-600">Свяжитесь со мной, и я помогу организовать ваше незабываемое путешествие</p>
          </div>
          <div className="bg-gradient-to-br from-blue-50 to-purple-50 rounded-3xl p-8 shadow-xl">
            <form onSubmit={handleSubmit} className="space-y-6" data-testid="contact-form">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-semibold text-gray-700 mb-2">Ваше имя *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                    placeholder="Введите ваше имя"
                    data-testid="contact-name"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">Email *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                    placeholder="your@email.com"
                    data-testid="contact-email"
                  />
                </div>
              </div>
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="phone" className="block text-sm font-semibold text-gray-700 mb-2">Телефон</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                    placeholder="+7 (___) ___-__-__"
                    data-testid="contact-phone"
                  />
                </div>
                <div>
                  <label htmlFor="tour" className="block text-sm font-semibold text-gray-700 mb-2">Выберите экскурсию</label>
                  <select
                    id="tour"
                    name="tour"
                    value={formData.tour}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                    data-testid="contact-tour-select"
                  >
                    <option value="">Выберите...</option>
                    {TOURS.map(tour => (
                      <option key={tour.id} value={tour.title}>{tour.title}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div>
                <label htmlFor="date" className="block text-sm font-semibold text-gray-700 mb-2">Желаемая дата</label>
                <input
                  type="date"
                  id="date"
                  name="date"
                  value={formData.date}
                  onChange={handleChange}
                  className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                  data-testid="contact-date"
                />
              </div>
              <div>
                <label htmlFor="message" className="block text-sm font-semibold text-gray-700 mb-2">Сообщение</label>
                <textarea
                  id="message"
                  name="message"
                  rows="4"
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                  placeholder="Расскажите о ваших пожеланиях..."
                  data-testid="contact-message"
                ></textarea>
              </div>
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl font-semibold hover:shadow-lg transform hover:-translate-y-0.5 transition text-lg disabled:opacity-50 disabled:cursor-not-allowed"
                data-testid="contact-submit"
              >
                {isSubmitting ? 'Отправка...' : 'Отправить заявку'}
              </button>
            </form>
            <div className="mt-8 pt-8 border-t border-gray-300">
              <div className="flex flex-col md:flex-row justify-center items-center gap-6 text-gray-700">
                <a href="mailto:polina.travel06@gmail.com" className="flex items-center hover:text-blue-600 transition">
                  <Mail className="w-5 h-5 mr-2 text-blue-600" />
                  <span>polina.travel06@gmail.com</span>
                </a>
                <a href="tel:+33755087309" className="flex items-center hover:text-blue-600 transition">
                  <Phone className="w-5 h-5 mr-2 text-blue-600" />
                  <span>+33 7 55 08 73 09</span>
                </a>
                <a href="https://wa.me/33755087309" target="_blank" rel="noopener noreferrer" className="flex items-center hover:text-blue-600 transition">
                  <MessageCircle className="w-5 h-5 mr-2 text-blue-600" />
                  <span>WhatsApp / Telegram</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8">
            <div>
              <h3 className="text-xl font-bold mb-4">О гиде</h3>
              <p className="text-gray-400 leading-relaxed">
                Профессиональный гид по Лазурному берегу с многолетним опытом и страстью к истории Франции.
              </p>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-4">Направления</h3>
              <ul className="space-y-2 text-gray-400">
                <li>• Ницца</li>
                <li>• Монако</li>
                <li>• Канны</li>
                <li>• Ментон</li>
                <li>• Эз-Вилляж</li>
                <li>• Кань-сюр-Мер</li>
              </ul>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-4">Контакты</h3>
              <div className="space-y-3 text-gray-400">
                <p>
                  <a href="mailto:polina.travel06@gmail.com" className="hover:text-white transition">
                    Email: polina.travel06@gmail.com
                  </a>
                </p>
                <p>
                  <a href="tel:+33755087309" className="hover:text-white transition">
                    Телефон: +33 7 55 08 73 09
                  </a>
                </p>
                <p>
                  <a href="https://wa.me/33755087309" target="_blank" rel="noopener noreferrer" className="hover:text-white transition">
                    WhatsApp: +33 7 55 08 73 09
                  </a>
                </p>
                <p>Лазурный берег, Франция</p>
              </div>
            </div>
          </div>
          <div className="mt-12 pt-8 border-t border-gray-800 text-center text-gray-400">
            <p>&copy; 2026 Экскурсии с Полиной. Все права защищены.</p>
          </div>
        </div>
      </footer>

      {/* Tour Details Modal */}
      {selectedTour && (
        <div 
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedTour(null)}
          data-testid="tour-modal"
        >
          <div 
            className="bg-white rounded-3xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Header with Image */}
            <div className="relative h-64 md:h-80">
              <img 
                src={selectedTour.image} 
                alt={selectedTour.title} 
                className="w-full h-full object-cover"
              />
              <button
                onClick={() => setSelectedTour(null)}
                className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm p-2 rounded-full hover:bg-white transition"
                data-testid="close-modal"
              >
                <X className="w-6 h-6 text-gray-700" />
              </button>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6">
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-2">{selectedTour.title}</h2>
                <div className="flex flex-wrap gap-4 text-white/90">
                  <div className="flex items-center">
                    <Clock className="w-4 h-4 mr-1" />
                    {selectedTour.duration}
                  </div>
                  <div className="flex items-center">
                    <MapPin className="w-4 h-4 mr-1" />
                    {selectedTour.location}
                  </div>
                  <div className="flex items-center">
                    <Users className="w-4 h-4 mr-1" />
                    {selectedTour.groupSize}
                  </div>
                </div>
              </div>
            </div>

            {/* Modal Content */}
            <div className="p-6 md:p-8">
              {selectedTour.fullDescription && (
                <>
                  <div className="mb-6">
                    <p className="text-lg text-gray-700 leading-relaxed">{selectedTour.fullDescription.intro}</p>
                  </div>

                  {selectedTour.fullDescription.sections && selectedTour.fullDescription.sections.map((section, index) => (
                    <div key={index} className="mb-6">
                      <h3 className="text-2xl font-bold text-gray-900 mb-3">{section.title}</h3>
                      <p className="text-gray-700 leading-relaxed">{section.content}</p>
                    </div>
                  ))}
                </>
              )}

              {/* Price and CTA */}
              <div className="mt-8 pt-6 border-t border-gray-200 flex flex-col md:flex-row items-center justify-between gap-4">
                <div>
                  <div className="text-3xl font-bold text-blue-600">{selectedTour.price}</div>
                  <div className="text-sm text-gray-500">за группу {selectedTour.groupSize}</div>
                </div>
                <a 
                  href="#contact" 
                  onClick={() => setSelectedTour(null)}
                  className="w-full md:w-auto px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-full font-semibold hover:shadow-lg transition text-center"
                  data-testid="modal-book-button"
                >
                  Забронировать экскурсию
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;